import React, { Component } from "react";
import Chip                 from 'material-ui/Chip';
//UTILS
import * as ROLES                  from "../Utils/Roles_Types";
import { LABEL_True, LABEL_False } from "../Utils/Strings/Labels";
import { checkNull , checkUserLanguage} from "../Utils/Check_Value";
import Moment from "react-moment";
import momentformat from "moment";

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE = checkUserLanguage(USERINFO);

class FilterChip extends Component {

    constructor(props){
        super(props);
    }

    render() {
        
        var keys = Object.keys(this.props.list);

        return (
            <div style={{display: "flex", flexWrap: "wrap"}}>
                {
                    keys.map(
                        (item, index) => {
                            var element = this.props.list[item];
                            if (checkNull(element)) return null;
                            var value = element.value;
                            if (checkNull(value)) return null;
                            //Controllo se e' una stringa data
                            if( typeof value === 'string' )
                                value = value.indexOf("GMT+") > -1 ? momentformat(value).format("YYYY-MM-DD") : value;
                            else if(typeof value.Filtro === 'boolean')
                                value = value ? LABEL_True[USERLANGUAGE] : LABEL_False[USERLANGUAGE];
                            else if( typeof value === 'object' && typeof value.getDate === 'function')
                                value = momentformat(value).format("YYYY-MM-DD");
                            return <Chip
                                        style           = { {margin: "10px"} }
                                        key             = { index }
                                        onRequestDelete = { () => { this.props.onDelete(element) } } >
                                        { element.label } : { value }
                                  </Chip>;
                        }
                            
                    )
                }
            </div>
        );
    }
}

export default FilterChip;


// WEBPACK FOOTER //
// ./src/Components/component_FilterChips.js